var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTodayRequestIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    rx: 18,
    fill: "#0000FF",
    fillOpacity: 0.1
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 26V25.3478C12 23.9641 12.5268 22.637 13.4645 21.6586C14.4021 20.6801 15.6739 20.1304 17 20.1304H18.25C19.5761 20.1304 20.8479 20.6801 21.7855 21.6586C22.7232 22.637 23.25 23.9641 23.25 25.3478V26M20.75 14.2609C20.75 15.1257 20.4208 15.9551 19.8347 16.5667C19.2487 17.1782 18.4538 17.5217 17.625 17.5217C16.7962 17.5217 16.0013 17.1782 15.4153 16.5667C14.8292 15.9551 14.5 15.1257 14.5 14.2609C14.5 13.396 14.8292 12.5666 15.4153 11.9551C16.0013 11.3436 16.7962 11 17.625 11C18.4538 11 19.2487 11.3436 19.8347 11.9551C20.4208 12.5666 20.75 13.396 20.75 14.2609Z",
    stroke: "#0000FF",
    strokeWidth: 1.28,
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTodayRequestIcon);
export default __webpack_public_path__ + "static/media/TodayRequestIcon.17558049c6b9d01d054e1ff0901c40ce.svg";
export { ForwardRef as ReactComponent };